import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ApplicationRef,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
  ValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { FormTemplateDataEntryService } from "./../services/form-template-data-entry.service";
import { IDataEntryForm } from "./../models/data-entry.model";
import { ZpDataService } from "./../services/zp-data.service";
import { TextDictionaryService } from "./../services/text-dictionary.service";
import textList from "../../assets/data/text-dictionary.json";
import countries from "../../assets/data/countries.json";
import { v4 as uuid } from "uuid";
import { NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { DynamicHelpers } from "./../helpers/dynamic-helpers";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "../models/user.model";
import { Subscription } from "rxjs";
import plantree from "../../assets/data/plan-tree.json";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { PreviousUrlService } from "../services/previous-url.service";
import { Location } from "@angular/common";
import { PlanReviewRoutesService } from "../services/plan-review-routes.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { ProfessionalFeaturesService } from "../services/professional-features.service";

@Component({
    selector: "dynamic-form-data-entry",
    templateUrl: "./dynamic-form-data-entry.component.html",
    styleUrls: ["./dynamic-form-data-entry.component.scss"],
    standalone: false
})
export class DynamicFormDataEntryComponent implements OnInit, OnDestroy {
  public selectFixBool: boolean;
  public formResult: string = "no results yet";
  public myFormGroup: FormGroup = new FormGroup({});
  public myFormTemplate: IDataEntryForm;
  public templateName;
  public isNfzUrl;
  public Id;
  public newItemId;
  public myItem = {};
  public sectionTitle = "";
  public showHelp = false;
  public removePerson;
  public form;
  // public onPersonChange;
  public myTextList = textList;
  public myCountries = countries;
  public buttonText = "Next";
  public myOptionItem;
  public otherFreeText = false;
  public message: string;
  public false;
  public showConfirmationModal;
  public showList = false;
  public hideList: string[] = [];
  public editMode = false;
  public dummyShowTrigger: boolean = false;
  statusGetetingStarted;
  //datePicker: NgbDateStruct;
  public date: { year: number; month: number };
  public submitted = false;
  public myUser: IUser;
  public subscription: Subscription;
  public dataIsLoaded: boolean;
  public id: any;
  public opt;
  public nextItem;
  @Input() public disabled: boolean;
  public breadCrumbText: any;
  public isIE = false;
  public previousLink: string;
  public statusTooltipMobile = [];
  public questionMarkMobile: boolean;
  public assetsPerm;
  public debtsPerm;
  public dailyLifePerm;
  public wishesPerm;
  public isDE = false;
  public myClient: any;
  public myClientSharedPlanUserId: any;
  public myCategoriesBalance: {}[];
  public itemName: any;
  public removeCheckmark: boolean;
  public removeToggle: boolean;
  public backTo: boolean;
  public returnToPlanReviewData: any;
  public getCategoryData: any;
  public currentUrl: string;
  public textAreaModel: string = "";
  public letterQuota: boolean = false;
  ownerPercentage: any;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public currencyChosen: string;
  currencyValue: any;
  showJointOwner: boolean;
  public ownersList: any = [];
  public owner: any;
  public isOwnerListEmpty: boolean;
  public selectedOwnersList: any = {};
  public errorMessage: boolean;
  public statusExplanations: boolean;
  public form_elem;
  public selectedOwners;
  public selectedOwner;
  public personToNotifyList;
  public allMySharedPlans: {}[];
  public sharedPlan;
  public sharedPlanCategories: any;
  public ownersHashmap: {} = {};
  public hideInfoShowBox: boolean;
  public mapping = {
    now: "viewer now",
    future: "viewer future",
  };
  public companyDetails: any;
  displayDelegateRelation: any;
  selectedValue: any;
  delegateRelation: any;
  explanations = [
    {
      title: "How ownership works",
      image: "how-works.svg",
      status: false,
      description:
        "When you add a financial item to your plan, you can allocate it to one or more owners. There are three ownership options.",
      options: [
        {
          title: "Sole owner",
          content:
            "The item is wholly owned by one person e.g. you or your spouse. The full value of the item is assigned to the owner in the Financial Summaries.",
        },
        {
          title: "Joint tenant",
          content:
            "The owners jointly own the whole item - this is common for married couples. The full value of the item is assigned to both owners in the Financial Summaries.",
        },
        {
          title: "Tenants in common",
          content:
            "The owners each own a specified share of the item. The specified share of the item is assigned to each owner in the Financial Summaries.",
        },
      ],
    },
    {
      title: "About Delegates",
      image: "delegate.svg",
      status: false,
      description:
        "Flexible sharing options allow you to share what you wish, when you wish with those closest to you in life.",
      options: [
        {
          title: "Contributor",
          content:
            "Allows your delegate to view and edit your plan so that they can help you to build and manage it.",
        },
        {
          title: "Viewer: Now",
          content:
            "Allows your delegate to view your plan, without the ability to edit it by themselves.",
        },
        {
          title: "Viewer: Future",
          content:
            "Allows your delegate to view your plan only when you pass away or if you lose mental capacity.",
        },
        {
          title: "Never",
          content:
            "Prevents your delegate from accessing your plan at all times.",
        },
      ],
    },
  ];
  statusExplanationsLink: any;
  isNFZ: any;
  

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateDataEntryService,
    private dictService: TextDictionaryService,
    private ZpDataService: ZpDataService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    private userInfoService: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private previousUrl: PreviousUrlService,
    private location: Location,
    private planReviewRoutes: PlanReviewRoutesService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private professionalFeatures: ProfessionalFeaturesService
  ) {
    this.planReviewRoutes.returnToPlanReview.subscribe((data) => {
      this.returnToPlanReviewData = data;
    });
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.getCategoryData = data;
    });
    this.isIE = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    this.selectFixBool = true;
    this.subscription = userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
    this.activatedRoute.paramMap.subscribe(async (params) => {
      this.templateName = params.get("templateName");
      this.isNfzUrl = params.get("isNFZ");
      this.Id = params.get("Id"); //for editting only -
      //both this and the dynamic edit component use the same html template.
      //The Id is not in use here.
      // this.dataIsLoaded = false;
      await this.loadProfessionalDataForNFZ();

      this.getFields();
      // this.dataIsLoaded = true;
    });
  }
  async ngOnInit() {
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log("subscription myUser: ", this.myUser);
    });
    // JDM: Active theme
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.newItemId = uuid();
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (
      this.previousLink != "/plan-review" &&
      this.previousLink != "/plan-review/assets" &&
      this.previousLink != "/plan-review/debts" &&
      this.previousLink != "/plan-review/dailyLife" &&
      this.previousLink != "/plan-review/wishes"
    ) {
      this.getCategoryData = null;
      this.returnToPlanReviewData = false;
    }
    // JDM: Set up the mobile tooltip
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
    setTimeout(() => {
      this.selectFixBool = false;
    });
    this.myClient =
      this.myUser && this.myUser.sharedPlanUserId
        ? this.myUser && this.myUser.sharedPlanUserId
        : this.myUser;
    this.myClientSharedPlanUserId = this.myUser && this.myUser.sharedPlanUserId;

    if (this.myUser.sharedPlanUserId) {
      this.sharedPlanCategories = await this.ZpDataService.getPlan(
        this.myUser.sharedPlanUserId
      );
      if (this.sharedPlanCategories) {
        for (let itemType in this.sharedPlanCategories) {
          for (let item of this.sharedPlanCategories[itemType]) {
            if (item.newJointOwners) {
              for (let owner of item.newJointOwners) {
                this.ownersHashmap[owner.owner.first + owner.owner.last] =
                  owner.owner;
              }
            }
          }
        }
        if (Object.values(this.ownersHashmap).length === 0) {
          const chosenPlan = JSON.parse(
            sessionStorage.getItem("chosenSharedPlan")
          );
          this.ownersHashmap[
            chosenPlan.clientFirstName + chosenPlan.clientLastName
          ] = {
            first: chosenPlan.clientFirstName,
            last: chosenPlan.clientLastName,
            relationship: "Plan holder",
            default: true,
          };
        }
        this.selectedOwners = this.ZpDataService.displaySharedPlansOwner(
          Object.values(this.ownersHashmap)
        );
      }
    } else {
      this.selectedOwners = this.myUser.jointOwners;
    }

    this.checkSectionsPlan();
    // JDM: Get the delegate relation.
    this.subscription = this.getInfoAndPassService.accessRightSection.subscribe(
      async (data) => {
        this.displayDelegateRelation = data;
        // console.log("displayDelegateRelation: ", this.displayDelegateRelation);
        // Ensure myFormGroup is initialized before setting the value
        if (this.myFormGroup) {
          // Add a delay to make sure that controls are created
          await new Promise((resolve) => setTimeout(resolve, 500));

          // Find the corresponding templateObject for the fieldId 'delegateRelation'
          const templateObject = this.myFormTemplate.fields.find(
            (obj) => obj.fieldid === "delegateRelation"
          );

          // Check if the templateObject is found
          if (templateObject) {
            // Get the fieldId from the templateObject
            const fieldId = templateObject.fieldid;
            // console.log("fieldId: ", fieldId);

            // Update the value of the form control in myFormGroup
            if (this.myFormGroup.controls[fieldId]) {
              this.myFormGroup.controls[fieldId].setValue(data);
            }
          }
        }

        // console.log("displayDelegateRelation - ", this.displayDelegateRelation);
      }
    );
  }

  
  

  async loadProfessionalDataForNFZ() {
    await this.professionalFeatures.checkProfessionalCompanyDetails(this.myUser);
    // Access companyDetails from ProfessionalFeaturesService
    this.companyDetails = this.professionalFeatures.companyDetails;
    console.log("companyDetails - ", this.companyDetails);
    if (this.companyDetails && this.companyDetails.nfz) {
      this.isNFZ = true;
    } else {
      this.isNFZ = false;
    }
    console.log("isNFZ - ", this.isNFZ);
    // Set dataIsLoaded to true
    this.dataIsLoaded = true;
  }

  closeExplanationAboutDelegates(event) {
    // console.log("close explanations + event: ", event);
    if (event) {
      this.statusExplanationsLink = false;
    }
  }

  async checkSectionsPlan() {
    this.myCategoriesBalance =
      await this.ZpDataService.getAllPlanCategoriesDashboardInfo(this.myUser);
  }

  async getFields() {
    // the appropriate form template from assets
    if (this.companyDetails && this.isNFZ) {
      console.log("companyDetails - ", this.companyDetails);
      console.log("isNFZ - ", this.isNFZ);
      this.myFormTemplate = await this.ftService.getFormTemplateAsyncForNFZ(
        this.templateName,
        this.companyDetails.professionalLicense
      );
    } else {
      console.log("companyDetails - ", this.companyDetails);
      console.log("isNFZ - ", this.isNFZ);
      this.myFormTemplate = await this.ftService.getFormTemplateAsync(
        this.templateName
      );
    }

    //An example of a possible implementation to keep all texts in a dictionary.
    //Works but not implemented.
    this.sectionTitle = await this.getText(this.myFormTemplate.sectionTitle);
    //adding fields to group for sending to save
    //otherwise we will add fields based on the template - see below.
    //I don't think we need these two fields when adding a new record
    this.myFormGroup.addControl("clientId", new FormControl(""));
    this.myFormGroup.addControl("Id", new FormControl(""));
    if (this.sectionTitle == "delegates") {
      this.myFormGroup.addControl("delegateId", new FormControl(""));
    }
    //adding system fields
    //region
    this.myFormGroup.addControl("lastUpdate", new FormControl(new Date()));
    this.myFormGroup.addControl("lastUpdateBy", new FormControl(""));
    this.myFormGroup.addControl("upToDateExpire", new FormControl(new Date()));
    this.myFormGroup.addControl("currencyValue", new FormControl(""));
    this.myFormGroup.addControl('lookupPersonToNitify', new FormControl(''));
    //endregion
    //Here we add the fields from the template as form objects
    this.myFormTemplate.fields.forEach(async (templateObject) => {
      if (templateObject.showFields) {
        templateObject.showFields.map((fieldToHide) => {
          this.hideList.push(fieldToHide);
        });
      }
      if (templateObject.inputtype.includes("conditionaldropdown")) {
        //adding urls in urlparamters that are fields to
        //the hidelist so they won't show up on init
        templateObject.urlparameters.forEach((element) => {
          if (element.urlArray) {
            element.urlArray.forEach((objectHideShow) => {
              if (objectHideShow.length > 0) {
                this.hideList.push(objectHideShow);
              }
            });
          }
        });
        //we need to give the form a kick in order to trigger the
        //hidding/showing of the correct objects
        //this.changeSelection(null, templateObject.urlparameters, localValue);
      }
      if (
        templateObject.inputtype == "radiobuttons" ||
        templateObject.inputtype == "yesnotogglehideshow"
      ) {
        //adding urls in urlparamters that are fields to
        //the hidelist so they won't show up on init
        templateObject.urlparameters.forEach((element) => {
          if (element.urlArray) {
            element.urlArray.forEach((url) => {
              if (url.length > 0) {
                this.hideList.push(url);
              }
              //}
            });
          }
        });
      }
      //#endregion
      //adding the controls. formarray etc. is for the addable lists.
      //the controls will have fieldIds from the form template. In the html is a scan
      //that use the information in the form templae to fill in texts,
      //decide what object type to use and more
      if (!templateObject.inputtype.includes("formarray")) {
        if (templateObject.validators) {
          var myValidators: ValidatorFn[] = [];
          var validators: [{}] = templateObject.validators;
          templateObject.validators.map((validator) => {
            switch (validator["type"]) {
              case "max":
                myValidators.push(Validators.max(validator["value"]));
                break;
              case "min":
                myValidators.push(Validators.min(validator["value"]));
                break;
              case "maxLength":
                myValidators.push(Validators.maxLength(validator["value"]));
                break;
              case "minLength":
                myValidators.push(Validators.minLength(validator["value"]));
                break;
              case "required":
                myValidators.push(Validators.required);
                break;
              case "email":
                myValidators.push(Validators.email);
                break;
            }
          });
          if (
            templateObject.mandatory &&
            !myValidators.includes(Validators.required)
          ) {
            myValidators.push(Validators.required);
            //This way I can put off adding the validators array to all the templates. And
            //rely on templateObject.mandatory - which needs to be deleted from the system - TODO
          }
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null, Validators.compose(myValidators))
            );
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([])
              );
            } else {
              if (
                templateObject.inputtype.includes("yesnotoggleconditional") ||
                templateObject.inputtype.includes(
                  "yesnotoggleconditionalDisplayNo"
                )
              ) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl("", Validators.compose(myValidators))
                );
              }
            }
          }
        } else {
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null)
            );
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([], Validators.required)
              );
            } else {
              if (templateObject.inputtype.includes("yesnotoggle")) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                if (templateObject.inputtype.includes("multicheckbox")) {
                  this.myFormGroup.addControl(
                    templateObject.fieldid,
                    new FormControl([])
                  );
                } else {
                  this.myFormGroup.addControl(
                    templateObject.fieldid,
                    new FormControl("")
                  );
                }
              }
            }
          }
        }
      } else {
        let myUser = this.myUser.sharedPlanUserId;
        if (this.myUser.sharedPlanUserId) {
          myUser = this.myUser.sharedPlanUserId;
        } else {
          myUser = this.myUser;
        }
        let userName;
        if (myUser == this.myUser) {
          userName = this.myUser.firstName + " " + this.myUser.lastName;
        } else {
          userName = this.myUser.delegate.clientName;
        }
        let sharedPlanUserName = "";
        if (templateObject.inputtype.includes("formarray")) {
          if (templateObject.inputtype.includes("columns")) {
            //formarray of groups
            //I don't think this code is ever run - don't know what "columns" are.
            //TODO - move the content of "captions"
            //(which are now actualy the field names, not the capptions - my bad) to a new property "columns" -
            //a list of fields
            //in the form array columns and then use "captions" to fill in the captions of the columns.

            var myGroup;
            if (templateObject.columns) {
              //TODO - dynamically generate the below
            }
            //this is not the best code I have ever written...
            switch (templateObject.columns[0]) {
              case "Name": {
                switch (templateObject.columns.length) {
                  case 2: {
                    myGroup = this.fb.group({ Name: userName, Email: "" });
                    break;
                  }

                  case 3: {
                    //property - formarrayfourcolumns
                    myGroup = this.fb.group({
                      Name: "",
                      Percentage: 0,
                    });
                    break;
                  }
                }
                break;
              }
              case "Owner": {
                //mortgages formarraythree colums
                myGroup = this.fb.group({ Owner: userName, Percentage: "" });
                break;
              }
              case "sharedPlanOwner": {
                //for shared plans
                myGroup = this.fb.group({
                  sharedPlanOwner: sharedPlanUserName,
                  Percentage: "",
                });
                break;
              }
              case "Income": {
                myGroup = this.fb.group({ Income: "", Description: "" });
                break;
              }
              case "Expense": {
                myGroup = this.fb.group({ Expense: "", Description: "" });
                break;
              }
            }
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormArray([myGroup])
            );
          } else {
            switch (templateObject.inputtype) {
              default: {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormArray([])
                );
                break;
              }
            }
          }
        } //the code below is never run, IMHO
        else {
          if (templateObject.inputtype.includes("number")) {
            this.myFormGroup.addControl(
              templateObject.fieldid,
              new FormControl(null)
            );
          } else {
            if (templateObject.inputtype.includes("multiselect")) {
              this.myFormGroup.addControl(
                templateObject.fieldid,
                new FormControl([])
              );
            } else {
              if (templateObject.inputtype.includes("yesnotoggle")) {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl(false)
                );
              } else {
                this.myFormGroup.addControl(
                  templateObject.fieldid,
                  new FormControl("")
                );
              }
            }
          }
        }
      }
      if (templateObject.listSource) {
        if (
          templateObject.inputtype == "dropdownshowmultiselect" ||
          templateObject.inputtype == "dropdownshowmultiselectid" ||
          templateObject.inputtype == "dropdownid"
        ) {
          let clientId = this.myUser
            ? this.myUser.sharedPlanUserId
              ? this.myUser.sharedPlanUserId
              : this.myUser.Id
            : undefined;
          //Get the dropdownlist
          templateObject.itemArray =
            await this.ZpDataService.getSectionItemIdsAndNames(
              templateObject.listSource,
              clientId,
              templateObject.itemType
            );
        } else {
          if (templateObject.inputtype != "multicheckbox") {
            templateObject.items = await this.ZpDataService.getSectionItemNames(
              templateObject.listSource,
              this.myUser ? this.myUser.Id : undefined,
              templateObject.itemType
            );
          }
        }
      }
    });
    //this.myFormGroup.setValidators(this.emailValidator());//for confirming email
    //disabling hidden fields so the validation won't check them
    this.hideList.map((objectToDisable) => {
      if (this.myFormGroup.controls[objectToDisable]) {
        this.myFormGroup.controls[objectToDisable].disable();
      } else {
        let kk = 0;
      }
    });
  }

  handlePersonData(personString?: string) {
    console.log("Received from child:", personString);

    if (this.myFormGroup.controls['personToNotifyForDigitalLegacy']) {
      this.myFormGroup.controls['personToNotifyForDigitalLegacy'].setValue(personString);
      console.log("personToNotifyForDigitalLegacy - ", this.myFormGroup.controls['personToNotifyForDigitalLegacy'].value);
    } else {
      console.warn("personToNotifyForDigitalLegacy does not exist in the form group.");
    }
  }

  toggleStatus(explanation: any): void {
    // console.log("clicked");
    explanation.status = !explanation.status;
  }

  toggleStatusByIndex(index: number): void {
    if (index >= 0 && index < this.explanations.length) {
      this.explanations[index].status = !this.explanations[index].status;
    }
  }

  async onSubmit() {
    this.dummyShowTrigger = false;
    if (this.myFormGroup.invalid) {
      var kuku = DynamicHelpers.findInvalidControls(this.myFormGroup);
      if (kuku && kuku.length > 0) {
        this.submitted = true;
        return;
      }
    }
    //checking if the itemname field was filled with the dropdownid object to save the textName. not nice
    //Do not use this.  I hope it isn't in use anymore. We save the ID instead.
    let comp = this.myFormTemplate.fields.find(
      (myField) => myField.inputtype == "dropdownid"
    );
    if (comp) {
      if (comp.fieldid == "itemName") {
        let myComp = document.getElementById("itemName");
        var lookupChosen: [{}];
        lookupChosen = myComp["options"]; //.find(mycomp=>mycomp["value"]==this.myFormGroup.value["itemName"]);
        let mytext = "";
        for (var i = 0; i < lookupChosen.length; i++) {
          if (lookupChosen[i]["value"] == this.myFormGroup.value["itemName"]) {
            mytext = lookupChosen[i]["text"];
          }
        }
        this.myFormGroup.addControl("lookupText", new FormControl(mytext));
        
      }
    }
    if (this.myFormTemplate.finished) {
      let myUserId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      //update the data of the item being held in the service
      //clearHiddenFieldValues checks all objects that are not
      //visible at save time and clear's thier data in order to prevent
      //unwanted data from being saved.
      await this.clearHiddenFieldValues();
      this.myFormGroup.value["Id"] = this.newItemId; //Guid like key for the new record
      this.myFormGroup.value["lastUpdate"] = new Date();
      this.myFormGroup.value["lastUpdateBy"] = this.myUser.Id;
      let currentUserId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      this.myFormGroup.value["clientId"] = currentUserId;
      this.disabled = true;
      if (this.myFormTemplate.sectionTitle == "general expenses") {
        this.myFormGroup.value["itemName"] = "General Expenses";
      }
      let pp = JSON.stringify(this.myFormGroup.value);
      //Data is beng stored and called from a JSON stored in application local variable.
      let data = await this.ZpDataService.addItem(
        pp,
        this.myFormTemplate.sectionTitle
      );
      if (data.success && this.myFormGroup.value["propertyId"]) {
        //only update the property associated w/ it if the item was successfully added (or else we can taint the data.
        if (this.myFormTemplate.sectionTitle == "insurance") {
          await this.ZpDataService.addInsuranceToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "mortgages") {
          await this.ZpDataService.addMortgageToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "utilities") {
          await this.ZpDataService.addUtilityToProperty(
            this.myFormGroup.value["Id"] == ""
              ? data.itemId
              : this.myFormGroup.value["Id"],
            this.myFormGroup.value["propertyId"],
            myUserId
          );
        }
        if (this.myFormTemplate.sectionTitle == "property") {
          //will update the UMI property field with the current user choices
          await this.ZpDataService.addPropertyToUtilitiesMortgagesInsurance(
            this.myFormGroup.value,
            myUserId
          );
        }
      }

      this.ZpDataService.addLog(
        this.sectionTitle,
        this.myFormGroup.value["Id"],
        this.myUser.Id,
        "",
        "",
        pp,
        "new"
      );
      if (window.location.href == "/plan-review") {
        this.location.back();
      } else {
        if (
          this.previousLink == "/plan-review" &&
          this.buttonText == "Finished"
        ) {
          this.router.navigate([this.previousLink]);
        } else if (
          (this.previousLink == "/home" ||
            this.previousLink == "/my-dashboard") &&
          this.buttonText == "Finished"
        ) {
          this.router.navigate([this.previousLink]);
        } else {
          this.goto(this.myFormTemplate.url);
          if (this.getCategoryData) {
            switch (this.getCategoryData) {
              case "categoryAssets":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/assets"]);
                break;
              case "categoryDebts":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/debts"]);
                break;
              case "categoryDailyLife":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/dailyLife"]);
                break;
              case "categoryWishes":
                this.getInfoAndPassService.getInfoAndPass(this.getCategoryData);
                this.router.navigate(["/plan-review/wishes"]);
                break;
            }
          }
        }
      }
    } else {
      if (window.location.href == "/plan-review") {
        this.location.back();
      } else {
        this.goto(this.myFormTemplate.url);
        this.returnToPlanReviewData;
        this.getCategoryData;
        this.currentUrl = this.router.url;
        this.checkPercentageOwner(this.ownerPercentage);
      }
    }
  }

  checkPercentageOwner(event) {
    this.ownerPercentage = event;
    if ((this.ownerPercentage = false)) {
      return false;
    }
  }

  checkOnKeyUp() {
    if (this.textAreaModel.length >= 185) {
      this.letterQuota = true;
    } else {
      this.letterQuota = false;
    }
  }

  getPreviousCurrencyValue(fieldId) {
    console.log('fieldId');
  }

  async clearHiddenFieldValues() {
    let template = this.templateName as string;
    template = template.substr(0, template.indexOf("_"));
    let editFormTemplate = await this.ftService.getFormTemplateAsync(
      template + "-edit"
    );
    DynamicHelpers.clearHiddenFieldValues(editFormTemplate, this.myFormGroup);
  }

  async refresh() {
    await this.ZpDataService.revalidateCache();
    this.ZpDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true })
    );
  }

  // JDM: Add a new item at the end of the form
  addNewItem() {
    if (this.myFormTemplate.finished == true) {
      const url = this.route.snapshot.url;
      const lastUrlSegment = url[url.length - 1].path;
      let modifiedUrlSegment;
      if (this.myFormTemplate.jointOwners == true) {
        modifiedUrlSegment = lastUrlSegment.replace(/_\d+$/, "_joint-owners");
      } else {
        modifiedUrlSegment = lastUrlSegment.replace(/_\d+$/, "_1");
      }
      setTimeout(() => {
        this.router.navigate(["/" + modifiedUrlSegment]);
        this.myFormGroup.reset;
      }, 1000);
    }
  }

  async goto(url?: string) {
    this.submitted = false;
    if (this.myFormGroup.invalid) {
      if (this.myFormTemplate.introItem == true) {
        this.router.navigate(["/" + this.myFormTemplate.url]);
      }
    } else {
      if (this.myFormTemplate.finished != true) {
        url = this.myFormTemplate.url;
        this.router.navigate(["/" + url]);
      } else {
        this.router.navigate(["/" + url]);
      }
    }
    this.previousLink = this.previousUrl.getPreviousUrl();
    // JDM: Check all the sections that can't move forward after coming back to the previous step
    switch (this.myFormTemplate.subject.toLowerCase()) {
      // JDM: Delegates
      case "tell us about your delegate":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Delegates Access Rights
      case "set your delegate's access permissions":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Pensions
      case "add a pension":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Property
      case "add a property":
        if (this.previousLink == this.myFormTemplate.url) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Utility
      case "add a utility":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "/utility_2_1" ||
          this.previousLink == "/utility_2_2" ||
          this.previousLink == "/utility_2_3" ||
          this.previousLink == "/utility_2_4" ||
          this.previousLink == "/utility_2_5" ||
          this.previousLink == "/utility_2_6" ||
          this.previousLink == "/utility_2_7" ||
          this.previousLink == "/utility_2_8" ||
          this.previousLink == "/utility_2_9"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Work
      case "add an employment":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "work_2_1" ||
          this.previousLink == "work_2_2"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Rent
      case "add a rent":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "rent_3_1" ||
          this.previousLink == "rent_3_2"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Online Account
      case "add an online account":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "online-account_2_1" ||
          this.previousLink == "online-account_2_2" ||
          this.previousLink == "online-account_2_3"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
      // JDM: Power of Attorney
      case "add a power of attorney":
        if (
          this.previousLink == this.myFormTemplate.url ||
          this.previousLink == "power-of-attorney_1" ||
          this.previousLink == "power-of-attorney_2" ||
          this.previousLink == "power-of-attorney_3"
        ) {
          this.router.navigate([this.myFormTemplate.url]);
        }
        break;
    }
  }

  backto() {
    this.location.back();
    this.backTo = true;
    this.removeCheckmark = true;
    this.removeToggle = true;
  }

  getCurrencyValue(currencyValueSelected) {
    this.myFormGroup.controls[currencyValueSelected.fieldId].setValue(
      currencyValueSelected.currencyValueToSend
    );
  }

  createNewOwner() {
    this.router.navigate(["/account-settings/itemOwners"]);
  }

  addOwnershipFormValue(ownerListSelected) {
    if (!ownerListSelected.error) {
      this.myFormGroup.controls[ownerListSelected.fieldId].setValue(
        ownerListSelected.newJointOwnershipToSend
      );
    } else {
      this.myFormGroup.invalid;
      this.submitted = false;
      this.errorMessage = true;
    }
  }

  getCheckboxValues(ev, data, fieldId) {
    const ownerObj = {
      owner: data,
    };
    if (ev.target.checked) {
      this.ownersList.push(ownerObj);
      this.selectedOwnersList[data.first + data.last] = true;
    } else {
      const el = this.ownersList.find((itm) => itm.owner === data);
      if (el) this.ownersList.splice(this.ownersList.indexOf(el), 1);
      this.selectedOwnersList[data.first + data.last] = false;
    }
    if (this.ownersList.length === 0) {
      this.isOwnerListEmpty = true;
    } else {
      this.isOwnerListEmpty = false;
    }
    this.addOwnershipFormValue({
      fieldId: fieldId,
      newJointOwnershipToSend: this.ownersList,
    });
  }

  toggleExplanations($event?) {
    $event.stopPropagation();
    this.statusExplanations = !this.statusExplanations;
  }

  forkClick(item, dummy, infoBox?) {
    this.myFormTemplate.url = item.url;
  }

  forkClickYesNo(fieldId, urlparameters) {
    var myElements: [] = urlparameters;
    if (this.myFormGroup.controls[fieldId].value) {
      let myElementNo = myElements.find((element) => element["option"] == "No");
      this.myFormTemplate.url = myElementNo["url"];
    } else {
      let myElementYes = myElements.find(
        (element) => element["option"] == "Yes"
      );
      this.myFormTemplate.url = myElementYes["url"];
    }
  }

  getCurrency(currency) {
    this.currencyChosen = currency;
  }

  forkClickYesNoHideShow(fieldId, urlparameters, init?, param?) {
    var myElements: [] = urlparameters;
    //if (this.myFormGroup.controls[fieldId].value) {
    let myElementYes = myElements.find((element) => element["option"] == "Yes");
    let myElementNo = myElements.find((element) => element["option"] == "No");
    var myInit = false;
    if (init) {
      myInit = true;
    }
    //enable the fields
    if (
      myInit
        ? this.myFormGroup.controls[fieldId].value
        : !this.myFormGroup.controls[fieldId].value
    ) {
      //Yes
      if (myElementYes["urlArray"][0]) {
        //it is a array of fields
        (myElementYes["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });

        (myElementNo["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["urlArray"]]) {
          this.myFormGroup.controls[myElementYes["urlArray"]].enable();
          this.manageHideFields("show", [myElementYes["urlArray"]]);
        }
        if (this.myFormGroup.controls[myElementNo["urlArray"]]) {
          this.myFormGroup.controls[myElementNo["urlArray"]].disable();
          this.manageHideFields("hide", [myElementNo["urlArray"]]);
        }
      }
    } //No
    else {
      //disable the fields
      if (myElementYes["urlArray"][0]) {
        //it is a array of fields
        (myElementYes["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].disable();
            this.manageHideFields("hide", [url]);
          }
        });

        (myElementNo["urlArray"] as Array<string>).forEach((url) => {
          if (this.myFormGroup.controls[url]) {
            this.myFormGroup.controls[url].enable();
            this.manageHideFields("show", [url]);
          }
        });
      } else {
        //one component without a array
        if (this.myFormGroup.controls[myElementYes["urlArray"]]) {
          this.myFormGroup.controls[myElementYes["urlArray"]].disable();
          this.manageHideFields("hide", [myElementYes["urlArray"]]);
        }
        if (this.myFormGroup.controls[myElementNo["urlArray"]]) {
          this.myFormGroup.controls[myElementNo["urlArray"]].enable();
          this.manageHideFields("show", [myElementNo["urlArray"]]);
        }
      }
    }
  }

  showHide(choice, showList) {
    if (choice == "Yes") {
      this.showList = true;
    } else {
      this.showList = false;
    }
  }

  showMe(fieldName) {
    if (!this.hideList) {
      return true;
    }
    if (this.hideList.length == 0) {
      return true;
    }
    if (this.hideList.includes(fieldName)) {
      return false;
    } else {
      return true;
    }
  }

  manageHideFields(choice, showList: string[]) {
    if (choice == "show") {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].enable();
        while (this.hideList.includes(kk)) {
          let index = this.hideList.indexOf(kk);
          this.hideList.splice(index, 1);
        }
      });
    } else {
      showList.map((kk) => {
        this.myFormGroup.controls[kk].disable();
        if (!this.hideList.includes(kk)) {
          this.hideList.push(kk);
          //valadation doesn't check controls that are disabled.
          //Otherwise if it was required it would throw a validation error
        }
      });
    }
    this.removeCheckmark = false;
    this.dummyShowTrigger = true;
  }

  onOptionSelected(event) {
    let value = event;
    let selected = value;
  }
  changeSelection(event, urls) {
    //added item? for dynamic edit
    //let selected = event.currentTarget.selectedOptions[0].innerHTML.trim() as string;
    let selected = event.target.value;
    var myUrlArray;
    let chosenUrlParameter = urls.find(
      (element) => element.option === selected
    );
    if (chosenUrlParameter.urlArray) {
      urls.forEach((param) => {
        if (param.urlArray) {
          param.urlArray.forEach((element2) => {
            if ((chosenUrlParameter.urlArray as [""]).includes(element2)) {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].enable();
                this.manageHideFields("show", [element2]);
              }
            } else {
              if (this.myFormGroup.controls[element2]) {
                this.myFormGroup.controls[element2].disable();
                this.manageHideFields("hide", [element2]);
              }
              // the field will be disabled and not submitted,
              //so we don't need to reset the content.
              //this.myFormGroup.controls[element.url].setValue("");
            }
          });
        }
      });
    } else {
      this.myFormTemplate.url = urls.find(
        (kk) => kk.option == selected.trim()
      ).url;
    }
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }
  changeItem(e, itemName: string) {
    this.myFormGroup.controls[itemName].setValue(e.target.value, {
      onlySelf: true,
    });
  }

  private MatchConfirm(controls: string[]) {
    return (checkForm: FormGroup) => {
      let value1 = checkForm.controls[controls[0]];
      let value2 = checkForm.controls[controls[1]];

      if (value1.value === value2.value) {
        return value2.setErrors(null);
      } else {
        return value2.setErrors({ notEquivalent: true });
      }
    };
  }

  public MatchConfirmed(e, controls: string[]) {
    if (!this.myFormGroup.controls[controls[0]]) {
      return;
    }
    if (!this.myFormGroup.controls[controls[1]]) {
      return;
    }
    let value1 = this.myFormGroup.controls[controls[0]];
    let value2 = this.myFormGroup.controls[controls[1]];

    if (value1.value === value2.value) {
      value2.setErrors(null);
    } else {
      value2.setErrors({ notEquivalent: true });
    }
  }

  cancelSave() {
    console.log("cancelSave");
  }

  confirmSave() {
    console.log("confirmSave");
  }

  handleSaveClick() {
    console.log("handleSaveClick");
  }

  onPersonChange(i, dataShared, dataSharedValue) {
    console.log("onPersonChange");
  }

  addPerson() {
    console.log("addPerson");
  }

  private emailValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      if (!group.controls["email"]) {
        return;
      }
      if (!group.controls["emailConfirm"]) {
        return;
      }
      const email = group.controls["email"];
      const confirmEmail = group.controls["confirmEmail"];
      if (email.value !== confirmEmail.value) {
        confirmEmail.setErrors({ notEquivalent: true });
      } else {
        confirmEmail.setErrors(null);
      }
      return;
    };
  }
  onSelectFocus(event) {
    console.log("onSelectFocus");
  }
  getIcon(mysection) {
    let myItemObject = plantree.find(
      (kk) => kk.sectionObjects["section"] == mysection
    )[0][""];
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
